import React, { Component } from 'react';
import { Row, Col, Button, Form, Card, Overlay, Tooltip } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Input from '../../../../../components/Input';
import { isNumber } from '../../../../../utils/ValidationUtil';
import { addDays } from '../../../../../utils/DateUtil';
import {
  cleanNumberFormat,
  formatCurrency,
  cleanFormatDate
} from '../../../../../utils/FormatUtil';
//import operation from '../../../../../components/SecurityFactors/config/OperationType';
import './simulator.css';
import DayPicker from '../DayPicker/DayPicker';
import simulatorConstants from '../config/config.simulator';

class Simulator extends Component {
  constructor() {
    super();

    this.attachRef = target => this.setState({target});
    this.state = {
      show: false,
      errorTextAmount: undefined,
      errorTextTimeLimit: undefined,
    };

    this.validateAmount = this.validateAmount.bind(this);
    this.validateTimeLimit = this.validateTimeLimit.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleDepositTypeChange = this.handleDepositTypeChange.bind(this);
    this.handleSimulationSubmit = this.handleSimulationSubmit.bind(this);
    this.handleExpirationDateChange = this.handleExpirationDateChange.bind(this);
    this.handleDefExpDate = this.handleDefExpDate.bind(this);
    this.handleTimeLimitChange = this.handleTimeLimitChange.bind(this);
  }

  componentDidMount() {

    const { getHolidays, timeLimit, disabledDays, googleAnalytics, getConfiguracionDap} = this.props;
    googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap'});
    if(disabledDays.length === 0){
      const today = new Date();
      const dateTo = addDays(today, simulatorConstants.RANGE_TIME_DAP, 0)
      const params = {
        fechaDesde: cleanFormatDate(today),
        fechaHasta: cleanFormatDate(dateTo),
        tipoRegistro: simulatorConstants.HOLIDAYS
      }
      getHolidays(params, timeLimit);
      
    }
    getConfiguracionDap();
  }

  validateAmount(e) {
    const amount = cleanNumberFormat(e.target.value);
    const { changeAmount } = this.props;

    if (!(amount >= 20000 && amount <= 900000000)) {
      this.setState({
        errorTextAmount:
          'Monto entre $20.000 y $900.000.000',
        show:true
      });
    } else {
      this.setState({
        errorTextAmount: undefined,
        show:true
      });
      changeAmount(amount);
    }
  }

  validateTimeLimit(e) {
    const timeLimit = e.target.value;
    const { changeTimeLimit } = this.props;

    if (!(timeLimit >= 7 && timeLimit <= 900)) {
      this.setState({
        errorTextTimeLimit: 'El plazo debe ser entre 7 y 900 días'
      });
    } else {
      this.setState({
        errorTextTimeLimit: undefined
      });
      changeTimeLimit(timeLimit);
    }
  }

  handleAmountChange(e) {
    const amount = cleanNumberFormat(e.target.value);
    const { changeAmount } = this.props;

    if (!(amount >= 20000 && amount <= 900000000)) {
      this.setState({
        errorTextAmount:
          'Monto entre $20.000 y $900.000.000',
        show:true
      });
    } else {
      this.setState({
        errorTextAmount: undefined,
        show:true
      });
      changeAmount(amount);
    }

    if (isNumber(amount) || amount === '') {
      changeAmount(amount);
    }
  }

  handleTimeLimitChange(e) {
    const timeLimit = cleanNumberFormat(e.target.value);
    const { changeTimeLimit } = this.props;

    if (!(timeLimit >= 7 && timeLimit <= 900)) {
      this.setState({
        errorTextTimeLimit: 'El plazo debe ser entre 7 y 900 días'
      });
    } else {
      this.setState({
        errorTextTimeLimit: undefined
      });
      changeTimeLimit(timeLimit);
    }

    if (isNumber(timeLimit) || timeLimit === '') {
      changeTimeLimit(timeLimit);
    }
  }

  handleDepositTypeChange(e) {
    const { changeDepositType } = this.props;
    changeDepositType(e.target.value);
  }

  handleSimulationSubmit(e) {
    e.preventDefault();

    const { amount, depositType, timeLimit, getSimulation, googleAnalytics } = this.props;
    const { errorTextAmount } = this.state;

    if (!errorTextAmount && amount && timeLimit) {
      getSimulation({ amount, depositType, timeLimit });

      googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap/paso1'});

      ReactGA.event({
        category: 'Click',
        action: 'Simular DAP'
      });
    }
  }

  handleExpirationDateChange(selectedDay) {
    const { changeExpirationDate, disabledDays } = this.props;
    changeExpirationDate(selectedDay, disabledDays);
  }

  handleDefExpDate(defExpDate){
    const { setDefaultExpDate } = this.props;
    setDefaultExpDate(defExpDate);
  }

  render() {

    const { amount, depositType, timeLimit, step, expirationDate, defaultExpirationDate, disabledDays, montoLimitDap } = this.props;
    const { errorTextAmount, errorTextTimeLimit, show, target } = this.state;

    if (step === 2) {
      return <Redirect to="/resultado-opciones" />;
    }

    return (
      <React.Fragment>
        <Row noGutters className="rotulos">
          <Col md={12}>
            <p>Simula tu Depósito a Plazo</p>
          </Col>
        </Row>
        <Card body>
          <Form>
            <Row noGutters>
              <Col md={{ span: 5, offset: 1 }} sm={6} xs={12}>
                <Col md={12} sm={12}>

                  <Input
                    ref={this.attachRef}
                    name="amount"
                    label="Monto"
                    helpText="Desde $20.000"
                    maxLength={13}
                    width="80%"
                    value={formatCurrency(amount)}
                    onBlur={(e) => {
                      this.validateAmount(e);
                      this.setState({
                        show: false
                      });
                    }}
                    onChange={this.handleAmountChange}
                    onFocus={this.validateAmount}
                    errorText={errorTextAmount}
                  />

                  <Overlay target={target} show={show} placement="top">

                     {
                       props => (
                         <Tooltip id="toolTipTop" {...props}>
                           Para la contratación de un Depósito a Plazo sobre <strong><label>{formatCurrency(montoLimitDap)}</label></strong> deberá ser realizada personalmente en nuestras oficinas.
                         </Tooltip>
                       )
                     }
                   </Overlay>

                </Col>
                {disabledDays.length > 0 && 
                <Col md={12} sm={12}>
                  <Form.Group>
                    <DayPicker
                      expirationDate={expirationDate}
                      defaultExpirationDate={defaultExpirationDate}
                      timeLimit={timeLimit}
                      handleDayChange={this.handleExpirationDateChange}
                      setDefExpDate={this.handleDefExpDate}
                      disabledDays={disabledDays}
                    />
                  </Form.Group>
                </Col>}
                {disabledDays.length === 0 && 
                <Col md={12} sm={12}>
                  <Input
                    name="timeLimit"
                    label="Plazo en días"
                    helpText="Mínimo 7 días"
                    maxLength={3}
                    width="30%"
                    value={timeLimit}
                    onBlur={this.validateTimeLimit}
                    onChange={this.handleTimeLimitChange}
                    onFocus={this.validateTimeLimit}
                    errorText={errorTextTimeLimit}
                  />
                </Col>}
                <Col md={12} sm={12}>
                  <Form.Group controlId="typeDepositRadios">
                    <Form.Label>Tipo de Depósito</Form.Label>
                    <br />
                    <Form.Check
                      name="tipoDap"
                      value="R"
                      checked={depositType === 'R'}
                      onChange={this.handleDepositTypeChange}
                      label="Renovable"
                      type="radio"
                      inline
                    />{' '}
                    <Form.Check
                      name="tipoDap"
                      value="F"
                      checked={depositType === 'F'}
                      disabled={amount < 100000}
                      onChange={this.handleDepositTypeChange}
                      label="Fijo"
                      type="radio"
                      inline
                    />{' '}
                  </Form.Group>
                  <p className="informacion">
                    <b>Montos de inversión Depósito a Plazo:</b>
                    <br />
                    Desde $20.000 para Renovable.
                    <br />
                    Desde $100.000 para Fijo.
                  </p>
                </Col>
                <Col md={12} sm={12}>
                  <Button
                    onClick={this.handleSimulationSubmit}
                    type="submit"
                    className="dap_btn-primary"
                    disabled={amount === '' || timeLimit === 0}
                  >
                    Simular
                  </Button>
                  <div className="dap_scroll">
                    <span>
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </div>
                </Col>
              </Col>
              <Col md={5} sm={6} xs={12} className="tips dap_border-izquierda">
                <Col md={12}>
                  <h5>Depósito a Plazo Renovable:</h5>
                  <p>
                    Desde el día de vencimiento, el titular dispondrá de 3 días hábiles, para solicitar el giro. 
                    Cumplido dicho plazo y no manifestando el titular su intención de renovar o girar, el depósito 
                    será renovado automáticamente a la tasa de pizarra vigente a la fecha de vencimiento
                    y por el plazo pactado originalmente y así sucesivamente, en cada nuevo vencimiento.
                  </p>
                  <h5>Depósito a Plazo Fijo:</h5>
                  <p>
                    Sólo devengará intereses en pesos hasta el momento de su vencimiento.
                  </p>
                  <hr />
                  <h5>Ventajas y Beneficios:</h5>
                  <ul>
                    <li>
                      <FontAwesomeIcon icon={faCheck} />
                      Excelente alternativa de ahorro.
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faCheck} />
                      Atractiva rentabilidad.
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faCheck} />
                      Exento de todo tipo de comisiones.
                    </li>
                  </ul>
                </Col>
              </Col>
            </Row>
          </Form>
        </Card>
      </React.Fragment>
    );
  }
}

export default Simulator;
